import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
    updateCurrentUser,
    verifyUserEmail,
    discardChanges,
    updateExternalIds,
    getNabpRoles
} from "../../actions/VirtualUserActions";
import NotificationsPopup from "newApp/components/common/NotificationsPopup";
import UsersUtility from "newApp/utilities/UsersUtility";
import UrlHelper from "newApp/utilities/UrlHelper";
import Api from "../../api/VirtualUserApi";

import { NabpRole } from "@p1s/p1s-common-react/entities";
import Header from "@p1s/p1s-common-react/Header";
import Profile from "@p1s/p1s-common-react/Profile";

export class ProfilePage extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this._onSignOut = this._onSignOut.bind(this);
        this.state = {};
    }

    componentDidMount() {
        import('./_profile.scss');

        const user = UsersUtility.getCurrentUser();
        this.setState({ user });
    }

    _onSignOut () {
        window.location = UrlHelper.getLogoutUrl();
    }

    componentDidUpdate (){
        const user = UsersUtility.getCurrentUser();

        if (this.state.user.hasUnverifiedEmail!==user.hasUnverifiedEmail)
            this.setState({ user });
    }

    updateCurrentUser = (user) => {
        this.setState({ user });
        this.props.updateCurrentUser(user);
    };

    checkExternalIdsUniqueness = async (user, externalIds) => {
        user.externalIdentifiers = externalIds;
        this.setState({ user });
        return await Api.checkExternalIdsUniqueness(user.organizationId, externalIds);
    };

    updateExternalIds = (user, externalIds) => {
        user.externalIdentifiers = externalIds;
        this.setState({ user });
        this.props.updateExternalIds(user, externalIds);
    }

    render() {
        const user = this.state.user;
        if (user == null)
            return null;

        const productSelectorPageUrl = UrlHelper.getIdentifiUrl() + "SsoAuth/ProductSelector";
        const organization = user && user.activeOrganizations ? user.activeOrganizations.find(o => o.id === user.organizationId) : {};

        return (
            <div id="profile">
                <Header currentVirtualUser={user}
                    currentOrganization={organization}
                    onProfileClick={this.onProfileClick}
                    showLocationMenu={() => {}}
                    logoutUser={this._onSignOut}
                    documentationUrl={GlobalSettings.DocumentationTrainingUrl}/>

                <div className="container-xs">
                    <Profile currentUser={user}
                        currentUrl={productSelectorPageUrl}
                        hasRouter={false}
                        onUserSave={this.updateCurrentUser}
                        waitForSend={this.props.waitForSend}
                        sentRecently={this.props.sentRecently}
                        verifyUserEmailAction={this.props.verifyUserEmail}
                        discardEmailChanges={this.props.discardChanges}
                        resendVerificationEmail={this.props.verifyUserEmail}
                        checkExternalIdsUniqueness={this.checkExternalIdsUniqueness}
                        updateExternalIds={this.updateExternalIds}
                        getNabpRoles={this.props.getNabpRoles}
                        nabpRoles={this.props.nabpRoles}
                    />

                </div>

                <NotificationsPopup/>
            </div>
        );
    }
}


ProfilePage.propTypes = {
    verifyUserEmail: PropTypes.func,
    waitForSend: PropTypes.bool,
    sentRecently: PropTypes.bool,
    goToUrl: PropTypes.func,
    discardChanges: PropTypes.func,
    updateExternalIds: PropTypes.func,
    getNabpRoles: PropTypes.func,
    nabpRoles: PropTypes.arrayOf(PropTypes.instanceOf(NabpRole))
};

const mapStateToProps = state => ({
    sentRecently: state.profileState.verificationEmailSent,
    waitForSend: state.profileState.verificationEmailSending,
    nabpRoles: state.profileState.nabpRoles
});

const mapDispatchToProps = (dispatch) => {
    return ({
        updateCurrentUser: (user) => dispatch(updateCurrentUser(user)),
        verifyUserEmail: (user, newEmail) => dispatch(verifyUserEmail(user, newEmail)),
        discardChanges: (user) => dispatch(discardChanges(user)),
        updateExternalIds: (user, externalIds) => dispatch(updateExternalIds(user, externalIds)),
        getNabpRoles: () => dispatch(getNabpRoles())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
